export const tablet = 768;
export const breakpoint = tablet;
